import { render } from "./RequestedListItem.vue?vue&type=template&id=22161d30&scoped=true"
import script from "./RequestedListItem.vue?vue&type=script&lang=js"
export * from "./RequestedListItem.vue?vue&type=script&lang=js"

import "./RequestedListItem.vue?vue&type=style&index=0&id=22161d30&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22161d30"]])

export default __exports__